module.exports = __webpack_public_path__ + "img/music-open.15b404d4.png";